<div class="website-audit-ux">
  <div class="website-audit-ux-header">
    <h1>UX</h1>
    <p>Evaluate your sites user experience across key areas</p>
  </div>
  <div class="website-audit-ux-scorecard-container">
    <div class="website-audit-ux-scorecards">
      <div
        *ngFor="let scoreCard of scoreCards"
        class="website-audit-ux-scorecard"
        [ngClass]="{
          selected: scoreCard.selected,
        }"
        (click)="selectScoreCard(scoreCard)"
      >
        <div
          class="ux-scorecard-icon"
          [ngClass]="{
            noIcon: !scoreCard.icon,
          }"
        >
          <mat-icon *ngIf="scoreCard.icon?.isMaterialIcon">{{
            scoreCard.icon?.icon
          }}</mat-icon>
        </div>
        <div class="ux-scorecard-text">
          <h1>
            {{ scoreCard.title }}

            <div class="ux-scorecard-value-pills-container">
              <div
                matTooltip="Current Score"
                matTooltipPosition="above"
                class="ux-scorecard-value-pill"
                [ngClass]="{
                  low_value: scoreCard.averageScore < 60,
                  mid_value:
                    scoreCard.averageScore >= 60 && scoreCard.averageScore < 80,
                  high_value: scoreCard.averageScore >= 80,
                }"
              >
                {{ scoreCard.averageScore }}
              </div>
              <mat-icon>arrow_right_alt</mat-icon>
              <div
                matTooltip="Optimal Score"
                matTooltipPosition="above"
                class="ux-scorecard-value-pill"
                [ngClass]="{
                  low_value: scoreCard.optimalScore < 60,
                  mid_value:
                    scoreCard.optimalScore >= 60 && scoreCard.optimalScore < 80,
                  high_value: scoreCard.optimalScore >= 80,
                }"
              >
                {{ scoreCard.optimalScore }}
              </div>
            </div>
          </h1>
          <p>{{ scoreCard.description }}</p>
        </div>
        <div class="ux-scorecard-actions">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </div>
      </div>
    </div>
    <div class="website-audit-ux-scorecard-main-content">
      <div class="main-content-header">
        <h1>{{ selectedScoreCard.title }}</h1>
      </div>
      <div class="main-content-issues-main main-content-issues-main-headers">
        <div
          class="main-content-issues"
          *ngIf="selectedScoreCard?.notWorkingWell?.length"
          [class.full_width]="!selectedScoreCard?.workingWell?.length"
        >
          <h1>Observed Issues</h1>
        </div>
        <div class="main-content-issues-separator" style="opacity: 0"></div>
        <div
          class="main-content-issues"
          *ngIf="selectedScoreCard?.workingWell?.length"
          [class.full_width]="!selectedScoreCard?.notWorkingWell?.length"
        >
          <h1>Positive Signals</h1>
        </div>
      </div>
      <div class="main-content-issues-main">
        <div
          class="main-content-issues"
          *ngIf="selectedScoreCard?.notWorkingWell?.length"
          [class.full_width]="!selectedScoreCard?.workingWell?.length"
        >
          <div
            class="main-content-issue not_working_well"
            *ngFor="let issue of selectedScoreCard.notWorkingWell"
          >
            <div class="main-content-issue-content">
              <h1>{{ issue.text }}</h1>
              <p>{{ issue.reason }}</p>
            </div>
          </div>
        </div>
        <div
          #separator
          class="main-content-issues-separator"
          *ngIf="
            selectedScoreCard?.workingWell?.length &&
            selectedScoreCard?.notWorkingWell?.length
          "
        ></div>
        <div
          class="main-content-issues"
          *ngIf="selectedScoreCard?.workingWell?.length"
          [class.full_width]="!selectedScoreCard?.notWorkingWell?.length"
        >
          <div
            class="main-content-issue working_well"
            *ngFor="let issue of selectedScoreCard.workingWell"
          >
            <div class="main-content-issue-content">
              <h1>{{ issue.text }}</h1>
              <p>{{ issue.reason }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Loader Overlay -->
<div class="loading-data-overlay" *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
